// Default React, React Components, Router and Services Components
import React, { useEffect, useState } from "react";
import {
  Box,
  Checkbox,
  Chip,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getMonth } from "utils/helper";

// Importing Custom Components
import MaterialUIButton from "components/commonComponents/button/button";
import MultipleAutocomplete from "components/commonComponents/autocomplete/multipleAutocomplete";

// Importing useStyles
import useStyles from "./qcReports.styles";

// Import Material Icons
import CloseIcon from "@mui/icons-material/Close";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import RestartAltOutlinedIcon from "@mui/icons-material/RestartAltOutlined";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import AlertDialog from "components/commonComponents/alertDialog";
import DoneIcon from "@mui/icons-material/Done";
import { countryDropdown, makeString } from "redux/manageissues/action";
import {
  filterBAU,
  getBAU,
  getCountrySource,
  getMakeSource,
  setProviderFilter,
} from "redux/app/actions";
import { getBauStatus } from "redux/reports/actions";
import {
  getProviderFilters,
  normalizedDropdown,
  providerDropdown,
  regionDropdown,
} from "redux/qcreports/action";
import { qcReports, statusCode } from "utils/enums";
function AdvanceFilters(props) {
  const [region, setRegion] = React.useState([]);
  const [provider, setProvider] = React.useState([]);
  const [normalizedProviderName, setNormalizedProviderName] = React.useState(
    []
  );

  const [show, setShow] = useState(false);
  const data1 = useSelector((state) => state.reports);
  const id = useSelector((state) => state.project.reports);
  const select = useSelector((state) => state.qcreports.filterProvider);
  const classes = useStyles();
  const dispatch = useDispatch();
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  // Declaration of States and Component Variables End Here
  useEffect(() => {
    getDataFormAPIForDropdown();
  }, []);

  const formik = useFormik({
    initialValues: {
      region: select.region,
      rawProviderName: select.rawProviderName,
      normalizedProviderName: select.normalizedProviderName,
      exportId: select.exportId,
    },

    onSubmit: (values) => {
      dispatch(setProviderFilter(values));
      props.filter({
        region: values.region.map((e) => e),
        rawProviderName: values.rawProviderName.map((e) => e),
        normalizedProviderName: values.normalizedProviderName.map((e) => e),
        exportId: [],
      });
    },
  });

  /******************************************************************************
  Function: reset
  Argument:
  Return:
  Usage:
  1.To reset the form values
  *******************************************************************************/

  const reset = () => {
    if (formik && formik.values) {
      //formik.resetForm();
      formik.values.region = [];
      formik.values.rawProviderName = [];
      formik.values.normalizedProviderName = [];
      formik.values.exportId = [];
      props.filter(
        {
          region: [],
          rawProviderName: [],
          normalizedProviderName: [],
          exportId: [],
        },
        true
      );
      dispatch(
        setProviderFilter({
          region: [],
          rawProviderName: [],
          normalizedProviderName: [],
          exportId: [],
        })
      );
    }
  };
  /******************************************************************************
  Function: getDataFormAPIForDropdown
  Argument:
  Return:
  Usage:
  1.To Call dropdown API 
  *******************************************************************************/

  const getDataFormAPIForDropdown = () => {
    dispatch(getProviderFilters(id)).then((res) => {
      if (res.status === statusCode.success) {
        if (res.data === qcReports.noRecordsFound) {
          setRegion([]);
          setProvider([]);
          setNormalizedProviderName([]);
        } else {
          setRegion(res.data?.region);
          setProvider(res.data?.rawProviderName);
          setNormalizedProviderName(res.data?.normalizedProviderName);
        }
      } else {
        setRegion([]);
        setProvider([]);
        setNormalizedProviderName([]);
      }
    });
  };

  return (
    // Advance Filter Form Start Here
    <Box>
      <Grid
        container
        spacing={2.5}
        alignItems="center"
        justifyContent="flex-start"
      >
        {/* Popup Title Start Here */}
        <Grid item xs={12}>
          <Grid
            container
            spacing={0}
            alignItems="center"
            justifyContent="flex-start"
          >
            <Grid item xs>
              <Typography variant="h6" gutterBottom>
                Advance Filter
              </Typography>
            </Grid>

            <Grid item xs={"auto"} textAlign="right">
              <Grid
                container
                spacing={0}
                alignItems="center"
                justifyContent="flex-start"
              >
                <Grid item xs="auto">
                  <MaterialUIButton
                    color="secondary"
                    message="RESET"
                    onClick={() => {
                      reset();
                    }}
                    startIcon={<RestartAltOutlinedIcon />}
                  />
                </Grid>
                <Grid item xs="auto">
                  <Tooltip title="Close " placement="bottom" arrow>
                    <IconButton
                      onClick={() => {
                        JSON.stringify(formik.initialValues) ===
                        JSON.stringify(formik.values)
                          ? props.close()
                          : setShow(true);
                      }}
                      color="secondary"
                      aria-label="Close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <MultipleAutocomplete
            labelId="Region"
            id="region"
            name="region"
            label="Region"
            onChange={(_, e) => {
              formik.setFieldValue("region", e);
            }}
            isOptionEqualToValue={(option, value) => {
              return option === value;
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  size="small"
                  variant="outlined"
                  label={option}
                  //{...getTagProps({ index })}
                />
              ))
            }
            value={formik.values.region}
            placeholder="Region"
            limitTags={3}
            options={region}
            getOptionLabel={(e) => e}
            renderOption={(props, e, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  size="small"
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {e}
              </li>
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <MultipleAutocomplete
            labelId="Provider"
            id="provider"
            name="rawProviderName"
            label="Provider"
            onChange={(_, e) => {
              formik.setFieldValue("rawProviderName", e);
            }}
            isOptionEqualToValue={(option, value) => {
              return option === value;
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  size="small"
                  variant="outlined"
                  label={option}
                  //{...getTagProps({ index })}
                />
              ))
            }
            value={formik.values.rawProviderName}
            placeholder="Provider name"
            limitTags={3}
            options={provider}
            getOptionLabel={(e) => e}
            renderOption={(props, e, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  size="small"
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {e}
              </li>
            )}
          />
        </Grid>{" "}
        <Grid item xs={12}>
          <MultipleAutocomplete
            labelId="Provider"
            id="provider"
            name="normalizedProviderName"
            label="Normalized ProviderName"
            onChange={(_, e) => {
              formik.setFieldValue("normalizedProviderName", e);
            }}
            isOptionEqualToValue={(option, value) => {
              return option === value;
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  size="small"
                  variant="outlined"
                  label={option}
                  //{...getTagProps({ index })}
                />
              ))
            }
            value={formik.values.normalizedProviderName}
            placeholder="Normalized Provider name"
            limitTags={3}
            options={normalizedProviderName}
            getOptionLabel={(e) => e}
            renderOption={(props, e, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  size="small"
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {e}
              </li>
            )}
          />
        </Grid>
        {/* Action Area Start Here */}
        <Grid item xs={12}>
          <Grid
            container
            spacing={2}
            alignItems="center"
            justifyContent="flex-start"
          >
            <Grid item xs="auto">
              <MaterialUIButton
                variant="outlined"
                message="FILTER"
                startIcon={<FilterListOutlinedIcon />}
                onClick={() => formik.handleSubmit()}
              />
            </Grid>
            <Grid item xs="auto">
              <MaterialUIButton
                variant="outlined"
                onClick={() => {
                  reset();
                }}
                message="RESET"
                startIcon={<RestartAltOutlinedIcon />}
              />
            </Grid>
            <Grid item xs="auto">
              <MaterialUIButton
                variant="outlined"
                message="CANCEL"
                startIcon={<EventBusyOutlinedIcon />}
                onClick={() => {
                  JSON.stringify(formik.initialValues) ===
                  JSON.stringify(formik.values)
                    ? props.close()
                    : setShow(true);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <AlertDialog
          open={show}
          onClose={() => setShow(false)}
          // open={isDeleted}
          title={"Confirmation"}
          // maxWidth={"sm"}
          description={`Do you want to discard the changes ?`}
          action={
            <Grid
              container
              alignItems="center"
              justifyContent="right"
              spacing={2}
              className={classes.alertDialogbtn}
            >
              <Grid item xs={"auto"}>
                <MaterialUIButton
                  variant="outlined"
                  onClick={() => {
                    setShow(false);
                    props.close();
                    reset();
                  }}
                  message="Yes"
                  startIcon={<DoneIcon />}
                />
              </Grid>
              <Grid item xs={"auto"}>
                <MaterialUIButton
                  variant="outlined"
                  onClick={() => {
                    setShow(false);
                  }}
                  message="No"
                  startIcon={<CloseIcon />}
                />
              </Grid>
            </Grid>
          }
        />
        {/* Action Area End Here */}
      </Grid>
    </Box>
    // Advance Filter Form End Here
  );
}

export default AdvanceFilters;
